import { render, staticRenderFns } from "./StorageDetailDialog.vue?vue&type=template&id=2c9ca00e&scoped=true&"
import script from "./StorageDetailDialog.vue?vue&type=script&lang=js&"
export * from "./StorageDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9ca00e",
  null
  
)

export default component.exports